/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserMachineLicenseListItem,
    MelcoModelsUserMachineLicenseListItemFromJSON,
    MelcoModelsUserMachineLicenseListItemFromJSONTyped,
    MelcoModelsUserMachineLicenseListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserMachineLicenseListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem
     */
    list: Array<MelcoModelsUserMachineLicenseListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem {
    return MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserMachineLicenseListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserMachineLicenseListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserMachineLicenseListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


